import { createFileRoute } from '@tanstack/react-router';

import { SchoolsOnboardingListRoot } from '@/features/schools-onboarding-list/components/SchoolsOnboardingListRoot';
import { AppPageContent } from '@/features/shared/components/AppPageContent';
import { AppPageHeader } from '@/features/shared/components/AppPageHeader';
import { UserRoles } from '@/lib/constants/auth.constants.ts';
import { requireRole } from '@/lib/validation';

export const Route = createFileRoute('/_app/app/admin-section/onboarding')({
  component: OnboardingComponent,
  beforeLoad: requireRole([UserRoles.ADMINISTRATOR]),
  ssr: false,
});

function OnboardingComponent() {
  return (
    <AppPageContent>
      <AppPageHeader title="Schools Onboarding" breadcrumbItems={[]} />
      <SchoolsOnboardingListRoot />
    </AppPageContent>
  );
}
